import React from 'react';
import PropTypes from 'prop-types';

const BasePage = props =>(
    <div className="wrapper">
        <section className="section-container">
            { props.children }
        </section>
    </div>
);

BasePage.propTypes = {
  children: PropTypes.any.isRequired
};

export default BasePage;
